export default () => ({
  searchTerm: '',
  pageSize: 10,
  sortDir: 'asc',
  orderBy: 'Last Name',
  filterBy: 0,
  filterOptions: [],
  technician: null,
  technicians: []
})



// WEBPACK FOOTER //
// ./src/store/modules/technicians/state.js